import { Box } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { WHATSAPP_NUMBER } from "../../constants";

export default function WhatsAppButton() {
  const handleClick = () => {
    const message = encodeURIComponent("Hey Protein Box, I need some help");
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, "_blank");
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        position: "fixed",
        bottom: { xs: 16, md: 24 },
        right: { xs: 16, md: 24 },
        width: { xs: 50, md: 60 },
        height: { xs: 50, md: 60 },
        backgroundColor: "#25D366",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        transition: "all 0.3s ease",
        zIndex: 1000,
        "&:hover": {
          backgroundColor: "#20BA5A",
          transform: "scale(1.1)",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <WhatsAppIcon
        sx={{
          color: "white",
          fontSize: { xs: 28, md: 34 },
        }}
      />
    </Box>
  );
}
